import React from 'react';
import { Users, CreditCard, Calendar, TrendingUp, Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import MetricCard from "@/components/dashboard/MetricCard";
import DashboardSection from "@/components/dashboard/DashboardSection";
import ResponsiveContainer from "@/components/dashboard/ResponsiveContainer";

const ParentDashboard = () => {
  const metrics = [
    { 
      icon: <Users className="h-5 w-5 sm:h-6 sm:w-6" />, 
      label: "Children", 
      value: "2",
      trend: { value: 0, isPositive: true }
    },
    { 
      icon: <Calendar className="h-5 w-5 sm:h-6 sm:w-6" />, 
      label: "Sessions", 
      value: "12",
      trend: { value: 2, isPositive: true }
    },
    { 
      icon: <TrendingUp className="h-5 w-5 sm:h-6 sm:w-6" />, 
      label: "Progress", 
      value: "88%",
      trend: { value: 5, isPositive: true }
    },
    { 
      icon: <CreditCard className="h-5 w-5 sm:h-6 sm:w-6" />, 
      label: "Balance", 
      value: "$240",
      trend: { value: 0, isPositive: true }
    }
  ];

  return (
    <ResponsiveContainer>
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <h2 className="text-2xl sm:text-3xl font-bold tracking-tight">Parent Dashboard</h2>
        <Button size="sm" className="w-full sm:w-auto">
          <Plus className="mr-2 h-4 w-4" /> Add Child
        </Button>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
        {metrics.map((metric, index) => (
          <MetricCard key={index} {...metric} />
        ))}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6">
        <DashboardSection
          title="Children's Schedule"
          description="Upcoming training sessions"
          action={<Button variant="outline" size="sm" className="w-full sm:w-auto">View Calendar</Button>}
        >
          <div className="space-y-3 sm:space-y-4">
            <div className="flex flex-col sm:flex-row sm:items-center justify-between py-2 gap-2">
              <div>
                <p className="font-medium">Sarah - Morning Training</p>
                <p className="text-xs sm:text-sm text-muted-foreground">Today, 6:00 AM - 8:00 AM</p>
              </div>
              <Button variant="ghost" size="sm" className="w-full sm:w-auto">Details</Button>
            </div>
            <div className="flex flex-col sm:flex-row sm:items-center justify-between py-2 gap-2">
              <div>
                <p className="font-medium">Michael - Evening Training</p>
                <p className="text-xs sm:text-sm text-muted-foreground">Today, 4:00 PM - 6:00 PM</p>
              </div>
              <Button variant="ghost" size="sm" className="w-full sm:w-auto">Details</Button>
            </div>
            <div className="flex flex-col sm:flex-row sm:items-center justify-between py-2 gap-2">
              <div>
                <p className="font-medium">Sarah - Competition Prep</p>
                <p className="text-xs sm:text-sm text-muted-foreground">Tomorrow, 9:00 AM - 11:00 AM</p>
              </div>
              <Button variant="ghost" size="sm" className="w-full sm:w-auto">Details</Button>
            </div>
          </div>
        </DashboardSection>

        <DashboardSection
          title="Payment History"
          description="Recent transactions and upcoming payments"
          action={<Button variant="outline" size="sm" className="w-full sm:w-auto">View All</Button>}
        >
          <div className="space-y-3 sm:space-y-4">
            <div className="flex flex-col sm:flex-row sm:items-center justify-between py-2 gap-2">
              <div>
                <p className="font-medium">Monthly Training Fee - Sarah</p>
                <p className="text-xs sm:text-sm text-muted-foreground">Paid on March 1, 2024</p>
              </div>
              <span className="text-sm font-medium text-red-600">-$120</span>
            </div>
            <div className="flex flex-col sm:flex-row sm:items-center justify-between py-2 gap-2">
              <div>
                <p className="font-medium">Monthly Training Fee - Michael</p>
                <p className="text-xs sm:text-sm text-muted-foreground">Paid on March 1, 2024</p>
              </div>
              <span className="text-sm font-medium text-red-600">-$120</span>
            </div>
            <div className="flex flex-col sm:flex-row sm:items-center justify-between py-2 gap-2">
              <div>
                <p className="font-medium">Competition Entry Fee - Sarah</p>
                <p className="text-xs sm:text-sm text-muted-foreground">Due on March 15, 2024</p>
              </div>
              <Button variant="ghost" size="sm" className="w-full sm:w-auto">Pay Now</Button>
            </div>
          </div>
        </DashboardSection>
      </div>
    </ResponsiveContainer>
  );
};

export default ParentDashboard; 